module.exports = __webpack_public_path__ + "img/base-double-wheel.73d374e0.png";